import { render, staticRenderFns } from "./the-superuser-header.vue?vue&type=template&id=5dc9d422&"
import script from "./the-superuser-header.vue?vue&type=script&lang=js&"
export * from "./the-superuser-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports